import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import isInView from '@src/utils/is-in-view';
import { getParameterByName } from '@src/utils/common-util';
import { aLink } from '@src/utils/common-util';
import $$tracker from '@src/tracker';
import { NEW_SERVER_SPECIAL_LINK } from '@src/constants/urls';
import { getCmsData } from './service';

class ContainerStore extends BaseStore {
  // 游戏对应官网地址
  @observable gameIndexUrl = 'https://jx.xoyo.com/index1/';

  // 游戏对应下载地址
  @observable gameDownloadUrl = 'https://jx.xoyo.com/index1/xz.html';

  @observable isShowAsideNav = false;

  // 滚动阈值
  SCROLL_THRESHOLD = 800;

  @observable
  asideNavList = [
    {
      name: '内功崛起',
      entireName: '内功崛起刷怪增伤',
      icon: require('./images/nav-item-1.png'),
      activeIcon: require('./images/nav-item-1-active.png'),
      anchor: '#section-1',
      tag: 1
    },
    {
      name: '门派调优',
      entireName: '门派调优武学焕新',
      icon: require('./images/nav-item-5.png'),
      activeIcon: require('./images/nav-item-5-active.png'),
      anchor: '#section-5',
      tag: 5
    },
    {
      name: '界面洞玄',
      entireName: '界面洞玄引脉通络',
      icon: require('./images/nav-item-2.png'),
      activeIcon: require('./images/nav-item-1-active.png'),
      anchor: '#section-2',
      tag: 2
    },
    {
      name: '开年新服',
      entireName: '开年新服喜迎侠士',
      icon: require('./images/nav-item-3.png'),
      activeIcon: require('./images/nav-item-1-active.png'),
      cmsId: 11504,
      outlink: true,
      href: NEW_SERVER_SPECIAL_LINK
    },
    {
      name: '礼酬侠士',
      entireName: '礼酬侠士福满江湖',
      icon: require('./images/nav-item-4.png'),
      activeIcon: require('./images/nav-item-1-active.png'),
      anchor: '#section-3',
      tag: 3
    },
    {
      name: '玩法焕新',
      entireName: '玩法焕新体验进阶',
      icon: require('./images/nav-item-5.png'),
      activeIcon: require('./images/nav-item-1-active.png'),
      anchor: '#section-4',
      tag: 4
    }
  ];

  @observable
  tabsList = {
    section2: [
      {
        name: '界面改造',
        tab: require('./images/s2-tab-1.png'),
        tabActive: require('./images/s2-tab-1-active.png'),
        subtitle: require('./images/s2-subtitle-1.png'),
        cmsId: 11516
      },
      {
        name: '修行秘籍',
        tab: require('./images/s2-tab-2.png'),
        tabActive: require('./images/s2-tab-2-active.png'),
        subtitle: require('./images/s2-subtitle-2.png'),
        cmsId: 11519
      }
    ],
    section2ActiveIndex: 0,
    section3: [
      {
        name: '决战烽火',
        tab: require('./images/s3-tab-1.png'),
        tabActive: require('./images/s3-tab-1-active.png'),
        subtitle: require('./images/s3-subtitle-1.png'),
        cmsId: 11517
      },
      {
        name: '帮会宝箱',
        tab: require('./images/s3-tab-2.png'),
        tabActive: require('./images/s3-tab-2-active.png'),
        subtitle: require('./images/s3-subtitle-2.png'),
        cmsId: 11520
      },
      {
        name: '新服礼卡',
        tab: require('./images/s3-tab-3.png'),
        tabActive: require('./images/s3-tab-3-active.png'),
        subtitle: require('./images/s3-subtitle-3.png'),
        cmsId: 11521
      },
      {
        name: '每日宝箱',
        tab: require('./images/s3-tab-4.png'),
        tabActive: require('./images/s3-tab-4-active.png'),
        subtitle: require('./images/s3-subtitle-4.png'),
        cmsId: 11522
      }
    ],
    section3ActiveIndex: 0,
    section5: [
      {
        name: '武魂堂',
        tab: require('./images/s5-tab-1.png'),
        tabActive: require('./images/s5-tab-1-active.png'),
        subtitle: require('./images/s5-subtitle-1.png'),
        cmsId: 11523
      },
      {
        name: '华山',
        tab: require('./images/s5-tab-2.png'),
        tabActive: require('./images/s5-tab-2-active.png'),
        subtitle: require('./images/s5-subtitle-2.png'),
        cmsId: 11524
      },
      {
        name: '少林',
        tab: require('./images/s5-tab-3.png'),
        tabActive: require('./images/s5-tab-3-active.png'),
        subtitle: require('./images/s5-subtitle-3.png'),
        cmsId: 11525
      },
      {
        name: '逍遥',
        tab: require('./images/s5-tab-4.png'),
        tabActive: require('./images/s5-tab-4-active.png'),
        subtitle: require('./images/s5-subtitle-4.png'),
        cmsId: 11526
      }
    ],
    section5ActiveIndex: 0
  };

  @observable cmsData = {};

  // 点击切换tab
  clickTab = (tag, index) => {
    $$tracker.clickSubtab(this.tabsList[tag][index].name);
    this.tabsList[`${tag}ActiveIndex`] = index;
  };

  changeUrlHashParam = tag => {
    const url = window.location.href;
    const hashIndex = url.indexOf('#');
    if (hashIndex === -1) return;

    const hashPart = url.substring(hashIndex + 1);
    const urlObj = new URL(hashPart, window.location.origin);
    urlObj.searchParams.set('section', tag);

    const newHash = urlObj.pathname + urlObj.search;
    window.location.hash = newHash;
  };

  isActiveNav = tag => {
    const currentPart = getParameterByName('section');
    return currentPart == tag;
  };

  /**
   * 滚动事件处理
   */
  currentTime = new Date().getTime();
  handleScroll = () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    this.isShowAsideNav = scrollTop > this.SCROLL_THRESHOLD;

    // 根据滚动位置自动切换columnCurrentIndex
    for (const el of document.querySelectorAll('[id^="section-"]')) {
      const tag = el.id.split('-')[1];
      const now = new Date().getTime();
      if (isInView(el) && now - this.currentTime > 300) {
        this.currentTime = now;
        $$tracker.exposeSection(this.asideNavList.find(i => i.tag == tag)?.entireName || '');
        this.changeUrlHashParam(tag);
        break;
      }
    }
  };

  clickNavItem = item => {
    $$tracker.clickNavTitle(item.name);
    if (item.outlink) {
      aLink(item.href);
      return;
    }
    this.toView(item.tag);
  };

  // 平滑滚动到指定区块
  toView = tag => {
    const element = document.querySelector(`#section-${tag}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  backtop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  toOfficial = () => {
    $$tracker.clickGoOfficial();
    aLink(this.gameIndexUrl);
  };

  downloadGame = () => {
    $$tracker.clickGoDownload();
    aLink(this.gameDownloadUrl);
  };

  use() {
    super.use();
    useMount(() => {
      $$tracker.loadInnerPage();
      const currentPart = getParameterByName('section');
      this.toView(currentPart);

      getCmsData().then(res => {
        this.cmsData = res;
      });

      window.addEventListener('scroll', this.handleScroll);
      // 返回清理函数，在组件卸载时执行
      return () => {
        window.scrollTo({
          top: 0,
          behavior: 'instant'
        });
        window.removeEventListener('scroll', this.handleScroll);
      };
    });
  }
}

export default ContainerStore;
